import fetchConTimeout, { esTimeout } from "./fetchConTimeout";

const { VUE_APP_TECNICAR: TECNICAR } = process.env;
class WebServiceTecnicar {
  constructor() {
    this.baseURL = TECNICAR;
  }

  async get(endPoint) {
    let respuesta = {
      message: "Vehículo no cuenta con póliza",
    };

    try {
      const requestOptions = {
        method: "POST",
        redirect: "follow",
      };

      const respuestaEnvio = await fetchConTimeout(
        `${this.baseURL}${endPoint}`,
        requestOptions
      );
      if (respuestaEnvio.ok) {
        const data = await respuestaEnvio.json();
        respuesta = await data.data;
        respuesta = {
          ...respuesta,
          message: "Vehículo con póliza en tecnicar",
          status: 200,
        };
      } else {
        respuesta = {
          status: 401,
          message: "Vehículo no cuenta con póliza",
        };
      }
    } catch (error) {
      respuesta = {
        status: esTimeout(error) ? 408 : 401,
        timeout: esTimeout(error),
        message: "Vehículo no cuenta con póliza",
      };
    }
    return respuesta;
  }
}

export default WebServiceTecnicar;
